import {
  GET_FILTERED_PRODUCTS_REQUEST,
  GET_FILTERED_PRODUCTS_SUCCESS,
  GET_FILTERED_PRODUCTS_FAILURE,
} from "../actions/productFilterActions";

const initialState = {
  products: [],
  loading: false,
  error: null,
  pagination: {},
};

const productFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FILTERED_PRODUCTS_REQUEST:
      return { ...state, loading: true, error: null };
    case GET_FILTERED_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload.data,
        pagination: action.payload.pagination,
      };
    case GET_FILTERED_PRODUCTS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default productFilterReducer;
